<template>
  <custome-Dialog
    :dialog-visible.sync="dialogVisible"
    :confirm-text="disabledBtn?'上传视频中...':'保存'"
    :title="title"
    width="30%"
    :confirm-disable="disabledBtn"
    @confirm="confirm"
    @close="close"
  >
    <div class="content">
      <el-form
        ref="createForm"
        :model="createForm"
        :rules="creatRules"
        label-width="120px"
      >
        <el-form-item
          label="线下视频章节名称"
          prop="showChapterName"
        >
          <el-input v-model="createForm.showChapterName" />
        </el-form-item>
        <el-form-item
          label="备注"
          prop="remark"
        >
          <el-input v-model="createForm.remark" />
        </el-form-item>
        <el-form-item
          label="选择日期"
          prop="showCreateTime"
        >
          <el-date-picker
            v-model="createForm.showCreateTime"
            type="date"
            :clearable="false"
            placeholder="选择日期"
            value-format="timestamp"
          />
        </el-form-item>
        <el-form-item
          label="上传视频"
          prop="videoUrl"
        >
          <div class="video-upload">
            <upload
              :file-list.sync="createForm.videoUrl"
              type="video"
              @isProcess="getProcess"
            />
            <div />
          </div>
        </el-form-item>
      </el-form>
    </div>
  </custome-Dialog>
</template>
<script>
import customeDialog from '@/components/common/dialog.vue';
import axClient from '@/services';
import upload from '@/components/common/upload/upload.vue';

export default {
  name: 'OfflineVideo',
  components: { customeDialog, upload },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    item: {
      type: [Object, null],
      default: null,
    },
  },
  data() {
    return {
      title: '线下视频编辑',
      cancelText: '取消',
      disabledBtn: false,
      createForm: {
        showChapterName: null,
        videoUrl: '',
        remark: null,
        id: null,
        userCourseCertId: null,
        showCreateTime: null,
      },
      creatRules: {
        showChapterName: [
          { required: true, message: '请输入线下视频章节名称', trigger: 'blur' },
        ],
        remark: [
          { required: false, message: '请输入线下视频备注', trigger: 'blur' },
        ],
        showCreateTime: [
          { required: true, message: '请选择创建时间', trigger: 'blur' },
        ],
        videoUrl: [
          { required: true, message: '请上传视频', trigger: 'blur' },
        ],
      },
    };
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        const {
          showChapterName,
          videoUrl,
          userCourseCertId,
          id,
          remark,
          showCreateTime,
        } = this.item;
        this.createForm = {
          showChapterName,
          videoUrl,
          userCourseCertId,
          id,
          remark,
          showCreateTime,
        };
        this.$nextTick(() => {
          this.$refs.createForm.clearValidate();
        });
      }
    },
  },
  methods: {
    // 关闭弹窗
    close() {
      this.$emit('update:dialogVisible', false);
      this.$emit('close');
    },
    // 上传过程中
    getProcess(value) {
      this.disabledBtn = value;
    },
    confirm() {
      this.$refs.createForm.validate(async (valid) => {
        if (valid) {
          const data = await axClient.cert.deleteVideoUpsert(this.createForm);
          if (!data) return;
          if (this.createForm.id) {
            this.$message.success('修改线下视频成功');
          }
          this.$emit('update:dialogVisible', false);
          this.$emit('confirm');
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.content {
  min-height: 200px;
  .wx-info {
    padding: 0 0 0 0;
    text-align: left;
    .item {
      margin-bottom: 15px;
      span {
        font-size: 12px;
        color: $--base-color-black;
        &:last-child {
          padding-left: 8px;
        }
      }
    }
  }
}

</style>
